"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _IPaperWrapper = require("./IPaperWrapper");
Object.keys(_IPaperWrapper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _IPaperWrapper[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _IPaperWrapper[key];
        }
    });
});
